const TestPackageGroupIndex = () =>
  import("@/pages/lab/testpackagegroup/TestPackageGroupIndex");
const TestPackageGroupDetail = () =>
  import("@/pages/lab/testpackagegroup/TestPackageGroupDetail");
const TestPackageGroupAdd = () =>
  import("@/pages/lab/testpackagegroup/TestPackageGroupAdd");
const TestPackageGroupEdit = () =>
  import("@/pages/lab/testpackagegroup/TestPackageGroupEdit");

export class TestPackageGroupRoutes {
  constructor() {
    this.route_root = "testpackagegroups";
    this.type_single = "Test Package Group";
    this.type_plural = "Test Package Groups";

    this.routes = [
      {
        path: this.route_root,
        name: `List of ${this.type_plural}`,
        component: TestPackageGroupIndex,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/add`,
        name: `Add ${this.type_single}`,
        component: TestPackageGroupAdd,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/:test_package_group_id`,
        name: `View ${this.type_single}`,
        component: TestPackageGroupDetail,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/:test_package_group_id/edit`,
        name: `Update ${this.type_single}`,
        component: TestPackageGroupEdit,
        meta: { requiresAuth: true }
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    const this_obj = new this();

    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    const this_obj = new this();

    return this_obj.public_routes;
  }
}
